import React from 'react';
import './Blogs.css'

const Blogs = () => {
    return (
        <div className='blogs'>
          <div>
              <h1>Question-1: What is the purpose of context API? </h1>
              <p> Ans-: The Context API is a React structure that enables us to exchange unique details and assists in solving prop-drilling from all levels of our application. The React Context API is a way for a React app to effectively produce global variables that can be passed around. This is the alternative to "prop drilling" or moving props from grandparent to child to parent, and so on. If some values are needed on different levels of the components tree and for many elements, it will be a good idea to use context for this data.</p>
          </div>
          <div>
              <h1>Question-2: what is symmetric tag in html?  </h1>
              <p> Ans-2: A semantic element clearly describes its meaning to both the browser and the developer. Elements such as header , footer and article are all considered semantic because they accurately describe the purpose of the element and the type of content that is inside them.  It makes web pages more informative and adaptable, allowing browsers. By providing this extra level of clarity, HTML5 semantic elements also help search engines to read the page and find the required information faster..</p>
          </div>
          <div>
              <h1>Question-3:What is inline vs inline-block elements?</h1>
              <p> Ans-3: <br />
              1. Displays an element as an inline element. Any height and width properties will have no effect. Such as: span, a, img tags are inline elements. <br />
              2. Inline-block elements are similar to inline elements, except they can have padding and margins added on all four sides. That means, we can set height and width values. 
              </p>
          </div>
        </div>
    );
};

export default Blogs;